import { DateTime } from 'luxon';

const timezones = {
  'Dateline Standard Time': 'DST',
  'UTC-11': 'U',
  'Hawaiian Standard Time': 'HST',
  'Alaskan Standard Time': 'AKDT',
  'Pacific Standard Time (Mexico)': 'PDT',
  'Pacific Daylight Time': 'PDT',
  'Pacific Standard Time': 'PST',
  'US Mountain Standard Time': 'UMST',
  'Mountain Standard Time (Mexico)': 'MDT',
  'Mountain Standard Time': 'MDT',
  'Central America Standard Time': 'CAST',
  'Central Standard Time': 'CDT',
  'Central Standard Time (Mexico)': 'CDT',
  'Canada Central Standard Time': 'CCST',
  'SA Pacific Standard Time': 'SPST',
  'Eastern Standard Time': 'EDT',
  'US Eastern Standard Time': 'UEDT',
  'Venezuela Standard Time': 'VST',
  'Paraguay Standard Time': 'PYT',
  'Atlantic Standard Time': 'ADT',
  'Central Brazilian Standard Time': 'CBST',
  'SA Western Standard Time': 'SWST',
  'Pacific SA Standard Time': 'PSST',
  'Newfoundland Standard Time': 'NDT',
  'E. South America Standard Time': 'ESAST',
  'Argentina Standard Time': 'ART',
  'SA Eastern Standard Time': 'SEST',
  'Greenland Standard Time': 'GDT',
  'Montevideo Standard Time': 'MST',
  'Bahia Standard Time': 'BST',
  'UTC-02': 'U',
  'Mid-Atlantic Standard Time': 'MDT',
  'Azores Standard Time': 'ADT',
  'Cape Verde Standard Time': 'CVST',
  'Morocco Standard Time': 'MDT',
  UTC: 'UTC',
  'GMT Standard Time': 'GDT',
  'British Summer Time': 'BST',
  'Greenwich Standard Time': 'GST',
  'W. Europe Standard Time': 'WEDT',
  'Central Europe Standard Time': 'CEDT',
  'Romance Standard Time': 'RDT',
  'Central European Standard Time': 'CEDT',
  'W. Central Africa Standard Time': 'WCAST',
  'Namibia Standard Time': 'NST',
  'GTB Standard Time': 'GDT',
  'Middle East Standard Time': 'MEDT',
  'Egypt Standard Time': 'EST',
  'Syria Standard Time': 'SDT',
  'E. Europe Standard Time': 'EEDT',
  'South Africa Standard Time': 'SAST',
  'FLE Standard Time': 'FDT',
  'Turkey Standard Time': 'TDT',
  'Israel Standard Time': 'JDT',
  'Libya Standard Time': 'LST',
  'Jordan Standard Time': 'JST',
  'Arabic Standard Time': 'AST',
  'Kaliningrad Standard Time': 'KST',
  'Arab Standard Time': 'AST',
  'E. Africa Standard Time': 'EAST',
  'Moscow Standard Time': 'MSK',
  'Samara Time': 'SAMT',
  'Iran Standard Time': 'IDT',
  'Arabian Standard Time': 'AST',
  'Azerbaijan Standard Time': 'ADT',
  'Mauritius Standard Time': 'MST',
  'Georgian Standard Time': 'GET',
  'Caucasus Standard Time': 'CST',
  'Afghanistan Standard Time': 'AST',
  'West Asia Standard Time': 'WAST',
  'Yekaterinburg Time': 'YEKT',
  'Pakistan Standard Time': 'PKT',
  'India Standard Time': 'IST',
  'Sri Lanka Standard Time': 'SLST',
  'Nepal Standard Time': 'NST',
  'Central Asia Standard Time': 'CAST',
  'Bangladesh Standard Time': 'BST',
  'Myanmar Standard Time': 'MST',
  'SE Asia Standard Time': 'SAST',
  'N. Central Asia Standard Time': 'NCAST',
  'China Standard Time': 'CST',
  'North Asia Standard Time': 'NAST',
  'Singapore Standard Time': 'MPST',
  'W. Australia Standard Time': 'WAST',
  'Taipei Standard Time': 'TST',
  'Ulaanbaatar Standard Time': 'UST',
  'North Asia East Standard Time': 'NAEST',
  'Japan Standard Time': 'JST',
  'Korea Standard Time': 'KST',
  'Cen. Australia Standard Time': 'CAST',
  'AUS Central Standard Time': 'ACST',
  'E. Australia Standard Time': 'EAST',
  'AUS Eastern Standard Time': 'AEST',
  'West Pacific Standard Time': 'WPST',
  'Tasmania Standard Time': 'TST',
  'Yakutsk Standard Time': 'YST',
  'Central Pacific Standard Time': 'CPST',
  'Vladivostok Standard Time': 'VST',
  'New Zealand Standard Time': 'NZST',
  'UTC+12': 'U',
  'Fiji Standard Time': 'FST',
  'Magadan Standard Time': 'MST',
  'Kamchatka Standard Time': 'KDT',
  'Tonga Standard Time': 'TST',
  'Samoa Standard Time': 'SST',
};

export default () => {
  // Check for luxon timezone abbreviation
  const luxonTimezone = DateTime.local().toFormat('ZZZZ');
  if (luxonTimezone && !luxonTimezone.includes('GMT')) return luxonTimezone;

  // Check for timezone abbreviation in list
  const dateTimezone = new Date()
    .toString()
    .match(/\(.+\)/g)[0]
    .slice(1, -1);
  if (dateTimezone in timezones) {
    return timezones[dateTimezone];
  }

  // Default abbreviation
  return luxonTimezone || new Date().toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2];
};
